import {
  Box,
  Container,
  Typography,
  Button,
  Stack,
  ButtonBase,
  useTheme
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import Link from "../../../atoms/mui/Link";

const TertiaryAffordanceBody = ({ label, palette }) => (
  <Box display="inline-flex" alignItems="center" sx={{ gap: 0.75 }}>
    <Typography variant="body2" color="primary">
      {label}
    </Typography>
    <FontAwesomeIcon
      icon={faArrowRight}
      style={{ color: palette.primary.main, fontSize: 12 }}
    />
  </Box>
);

const TertiaryAffordance = ({ link, palette }) => {
  if (link.onClick) {
    return (
      <ButtonBase onClick={link.onClick} sx={{ p: 0 }}>
        <TertiaryAffordanceBody label={link.label} palette={palette} />
      </ButtonBase>
    );
  }
  return (
    <Link href={link.href}>
      <TertiaryAffordanceBody label={link.label} palette={palette} />
    </Link>
  );
};

const Hero = ({
  headline,
  subheadline,
  description,
  primaryCta,
  secondaryCta,
  tertiaryLink,
  visual
}) => {
  const { palette } = useTheme();
  const hasVisual = Boolean(visual);

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        bgcolor: palette.background.paper,
        position: "relative"
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: hasVisual
              ? { xs: "1fr", md: "1fr 1fr" }
              : "1fr",
            gap: { xs: 4, md: 6 },
            alignItems: "center"
          }}
        >
          <Box>
            <Box mb={2}>
              <Typography variant="h1" color="textPrimary">
                {headline}
              </Typography>
            </Box>
            {subheadline && (
              <Box mb={2}>
                <Typography variant="h5" color="textPrimary">
                  {subheadline}
                </Typography>
              </Box>
            )}
            {description && (
              <Box mb={3}>
                <Typography variant="body1" color="textSecondary">
                  {description}
                </Typography>
              </Box>
            )}

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1.5}
              sx={{ mb: tertiaryLink ? 2.5 : 0 }}
            >
              {primaryCta && (
                <Link href={primaryCta.href}>
                  <Button variant="contained" size="large" color="primary">
                    {primaryCta.label}
                  </Button>
                </Link>
              )}
              {secondaryCta && (
                <Link href={secondaryCta.href}>
                  <Button variant="outlined" size="large" color="primary">
                    {secondaryCta.label}
                  </Button>
                </Link>
              )}
            </Stack>

            {tertiaryLink && (
              <Box>
                <TertiaryAffordance link={tertiaryLink} palette={palette} />
              </Box>
            )}
          </Box>

          {hasVisual && (
            <Box
              sx={{
                position: "relative",
                width: "100%",
                minHeight: { xs: 240, md: 380 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              {visual}
            </Box>
          )}
        </Box>
      </Container>
    </Box>
  );
};
export default Hero;
